import styled, { css } from 'styled-components';
import { tokens } from '../../../design/tokens';

import { BadgeTone } from './index';

const tones = {
  positive: css`
    color: ${tokens.color.marqueeGold};
    border-color: ${tokens.color.marqueeGold};
  `,

  warning: css`
    color: ${tokens.color.focusAmber};
    border-color: ${tokens.color.focusAmber};
  `,
  neutral: css`
    color: ${tokens.color.textAsh};
    border-color: ${tokens.color.railGraphite};
  `,
  negative: css`
    color: ${tokens.color.errorRed};
    border-color: ${tokens.color.errorRed};
  `,
};

export const Badge = styled.span<{ tone: BadgeTone }>`
  display: inline-block;
  padding: 2px 10px;
  border-radius: ${tokens.radius.pill};
  border: 1px solid;
  font-size: ${tokens.font.caption.size};
  font-weight: 500;
  white-space: nowrap;

  ${({ tone }) => tones[tone]}
`;
